import React from "react";
import classNames from "classnames";

import { ReactComponent as GreenRightArrow } from "@images/icons/green-right-arrow-icon.svg";
import Group from "@components/arrangement/Group/Group";

import "./ToolsCard.scss";

interface ToolsCardProps {
  name: string;
  description: string;
  recommendedText?: string;
  image: {
    src: string;
    alt?: string;
    width?: number;
    height?: number;
  };
  className?: string;
}

const ToolsCard = ({ name, description, recommendedText, image, className }: ToolsCardProps) => {
  const classes = classNames("tools-card", className);

  return (
    <div className={classes}>
      <div className="tools-card__image">
        <img
          src={image.src}
          alt={image.alt || name}
          width={image.width || 215}
          height={image.height || 180}
          className="tools-image"
        />
      </div>

      <div className="tools-card__main">
        <h3 className="title green-1">{name}</h3>
        <p className="description">{description}</p>

        {recommendedText && (
          <Group colGap={10} alignItems="flex-start">
            <span>
              <GreenRightArrow />
            </span>

            <p className="recommended-text">{recommendedText}</p>
          </Group>
        )}
      </div>
    </div>
  );
};

export default ToolsCard;
